import React from "react";
import {
  FeedbackPromptActionButton,
  FeedbackPromptActions,
} from "./PortalFeedbackPromptActions.styles";

interface PortalFeedbackPromptActionsProps {
  onNotNow: () => void;
  onGiveFeedback: () => void;
}

export const PortalFeedbackPromptActions: React.FC<
  PortalFeedbackPromptActionsProps
> = ({ onNotNow, onGiveFeedback }) => (
  <FeedbackPromptActions>
    <FeedbackPromptActionButton onClick={onNotNow} type="button">
      NOT NOW
    </FeedbackPromptActionButton>
    <FeedbackPromptActionButton onClick={onGiveFeedback} type="button">
      GIVE FEEDBACK
    </FeedbackPromptActionButton>
  </FeedbackPromptActions>
);
